export default __webpack_public_path__ + "static/media/github.d1bb13ce.svg";